export default __webpack_public_path__ + "static/media/phone-simple-error.8a9b3fbb.svg";